import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Stack } from "@mui/material";
import styles from "./landingPage.module.css";
import { LANDING_FAQ_DATA } from "../../data/FAQs";

export default function Faq() {
  const [expandedPanel, setExpandedPanel] = useState("landing-panel-1");

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  const iconStyle = (isExpanded) => ({
    background: isExpanded
      ? "linear-gradient(144deg, #5146e5 0%, #7b3aed 89%)"
      : "#F7F7FF",
    borderRadius: "8px",
    color: isExpanded ? "white" : "#6F6C90",
    padding: "4px 6px",
    fontSize: "18px",
  });

  const renderFaqItem = (faq) => {
    const isExpanded = expandedPanel === faq.id;

    return (
      <Accordion
        className="rounded"
        elevation={3}
        expanded={isExpanded}
        onChange={handleChange(faq.id)}
        key={faq.id}
      >
        <AccordionSummary
          expandIcon={
            <Box sx={iconStyle(isExpanded)}>
              {isExpanded ? <RemoveIcon /> : <AddIcon />}
            </Box>
          }
          aria-controls={faq.id}
          id={faq.id}
          className="accordion-text"
        >
          {faq.question}
        </AccordionSummary>
        <AccordionDetails>
          <p className="faq-content">{faq.answer}</p>
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <div>
      <div className="container">
        <div
          className={`${styles.panel_content} ${styles.contract_content} ${styles.panel_content1}`}
        >
          <div>
            <h2> Frequently Asked Questions</h2>
            <p className="m-0 w-100 max-windh">
              All you need to know about Lawblocks AI
            </p>
          </div>
        </div>
        <div className="row justify-content-center">
          <Stack spacing={1.2} className="col-lg-4">
            {LANDING_FAQ_DATA.slice(0, 3).map(renderFaqItem)}
          </Stack>

          <Stack spacing={1.2} className="col-lg-4 accordion-m">
            {LANDING_FAQ_DATA.slice(3).map(renderFaqItem)}
          </Stack>
        </div>
      </div>
    </div>
  );
}
